import {
  PIKKO_JACKPOT_OFFER_STATUS_REQUEST,
  PIKKO_JACKPOT_OFFER_STATUS_SUCCESS,
  PIKKO_JACKPOT_OFFER_STATUS_FAIL,
  PIKKO_JACKPOT_REACTIVATE_REQUEST,
  PIKKO_JACKPOT_REACTIVATE_SUCCESS,
  PIKKO_JACKPOT_REACTIVATE_FAIL,
  PIKKO_JACKPOT_RESET,
  PIKKO_JACKPOT_DISPLAY_TYPE,
} from '../constants/pikkoJackpotConstants';
import { PIKKO_JACKPOT_ENDPOINTS } from '../constants/services/pikkoJackpotEndpoints';

export const getJackpotOfferStatus =
  (phoneNumber, storeId, orderId, axiosInstance) => async (dispatch) => {
    dispatch({ type: PIKKO_JACKPOT_OFFER_STATUS_REQUEST });

    try {
      const { data } = await axiosInstance.get(
        PIKKO_JACKPOT_ENDPOINTS.WEBAPP_OFFER_STATUS,
        { params: { phoneNumber, storeId, orderId } },
      );

      const offer = { ...(data?.data || data), phoneNumber };
      localStorage.setItem('pikkoJackpot', JSON.stringify(offer));
      dispatch({ type: PIKKO_JACKPOT_OFFER_STATUS_SUCCESS, payload: offer });
    } catch (error) {
      const message = error?.response?.data?.message || error.message;
      console.error('Error fetching jackpot offer status:', error);
      dispatch({ type: PIKKO_JACKPOT_OFFER_STATUS_FAIL, payload: message });
    }
  };

export const reactivateJackpotOffer =
  (phoneNumber, orderId, axiosInstance) => async (dispatch) => {
    dispatch({ type: PIKKO_JACKPOT_REACTIVATE_REQUEST });

    try {
      const { data } = await axiosInstance.post(
        PIKKO_JACKPOT_ENDPOINTS.REACTIVATE,
        { phoneNumber, orderId },
      );

      const reactivatedOffer = { ...(data?.data || data), displayType: PIKKO_JACKPOT_DISPLAY_TYPE.REMINDER };
      localStorage.setItem('jackpot', JSON.stringify(reactivatedOffer));
      dispatch({ type: PIKKO_JACKPOT_REACTIVATE_SUCCESS, payload: reactivatedOffer });
    } catch (error) {
      const message = error?.response?.data?.message || error.message;
      const code = error?.response?.data?.error?.code || null;
      const status = error?.response?.status || null;
      console.error('Error reactivating jackpot offer:', error);
      dispatch({ type: PIKKO_JACKPOT_REACTIVATE_FAIL, payload: { message, code, status } });
    }
  };

export const resetPikkoJackpot = () => (dispatch) => {
  localStorage.removeItem('pikkoJackpot');
  dispatch({ type: PIKKO_JACKPOT_RESET });
};
